import React from 'react';

export default function Card() {
  return <svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M34.2 7.5H3.8V3.75H34.2V7.5ZM34.2 26.25H3.8V15H34.2V26.25ZM34.2 0H3.8C1.691 0 0 1.66875 0 3.75V26.25C0 27.2446 0.400356 28.1984 1.11299 28.9016C1.82563 29.6049 2.79218 30 3.8 30H34.2C35.2078 30 36.1744 29.6049 36.887 28.9016C37.5996 28.1984 38 27.2446 38 26.25V3.75C38 1.66875 36.29 0 34.2 0Z" fill="white"/>
	</svg>
}
